import {
  LOAD_PRODUCTS,
  PRODUCTS_LOADED,
  LOAD_PRODUCTS_BY_IDS,
  PRODUCTS_BY_IDS_LOADED,
  LOAD_PRODUCTS_ATTRIBUTES,
  PRODUCTS_ATTRIBUTES_LOADED,
  SEARCH_PRODUCTS,
  SEARCH_PRODUCTS_LOADED,
  SYNC_FAILED,
  RESET_PRODUCTS,
  RESET_SEARCH_PRODUCTS,
} from './actionTypes';
import { IProductsState } from './types';

export const initialState = {
  error: null,
  productsLoaded: false,
  products: [],
  productsByIdsLoaded: false,
  productsByIds: [],
  productsAttributesLoaded: false,
  productsAttributes: {},
  searchProductsLoaded: false,
  searchProducts: [],
  searchTotalCount: 0,
  syncing: false,
  syncingByIdCount:0
};

export const reducer = (state:IProductsState = initialState, action: { type: any; payload?: any }) => {
  switch (action.type) {
    case LOAD_PRODUCTS:
      return { ...state, error: null, syncing: true };
    case PRODUCTS_LOADED:
      return {
        ...state,
        error: null,
        products: action.payload,
        syncing: false,
        productsLoaded: true,
      };
    case LOAD_PRODUCTS_BY_IDS:
      return { ...state, syncing: true,syncingByIdCount:state.syncingByIdCount + 1 };
    case PRODUCTS_BY_IDS_LOADED:
      return {
        ...state,
        error: action.payload.error,
        productsByIds: [...state.productsByIds,...action.payload.data],
        syncing: false,
        productsByIdsLoaded: true,
        syncingByIdCount: state.syncingByIdCount-1
      };
    case LOAD_PRODUCTS_ATTRIBUTES:
      return { ...state, error: null, syncing: true };
    case PRODUCTS_ATTRIBUTES_LOADED:
      return {
        ...state,
        error: null,
        productsAttributes: { ...state.productsAttributes, ...action.payload },
        syncing: false,
        productsAttributesLoaded: true,
      };
    case SEARCH_PRODUCTS:
      return { ...state, error: null, syncing: true };
    case SEARCH_PRODUCTS_LOADED:
      return {
        ...state,
        error: null,
        searchProducts: action.payload.items,
        searchTotalCount: action.payload.totalCount,
        syncing: false,
        searchProductsLoaded: true,
      };
    case RESET_PRODUCTS:
      return { ...initialState,error: state.error, syncingByIdCount:state.syncingByIdCount };
    case RESET_SEARCH_PRODUCTS:
      return { ...state, searchProductsLoaded: false, searchProducts: [], searchTotalCount: 0 };
    case SYNC_FAILED:
      return { ...state, syncing: false, error: action.payload };
    default:
      return state;
  }
};
